import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
    titleGroup: {
        borderBottom: '1px solid rgb(204, 204, 204)', 
        paddingBottom: 8, 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center', 
        cursor: 'pointer', 
        marginBottom: 12
    },
    arrowGroup: {
        fill: '#fff',
        width: 15,
        height: 15,
    },
    headerGroup: {
        padding: 0, 
        margin: 0, 
        userSelect: 'none',
    },
}))

export {
    useStyles
}